export const importHtml = async (doc = document) => {
  const isDev = window.location.hostname.includes("192.168.") || window.location.hostname.includes("127.0") || window.location.hostname.includes("localhost");
  if (!isDev) return;
  const soltList = $(doc).find("yige-solt");
  if (!soltList.length) return;
  const promises:Promise<void>[] = [];
  soltList.each((_i, item) => {
    const promise = (async () => {
      const type = $(item).attr("data-type");
      const page = $(item).attr("data-html");
      const id = page?.split("-")[1];
      const DOMString = await $.ajax({
        url: `/public/static/src/page/components/${type}/${page}.html`,
        method: "GET",
      });
      if (!DOMString) return;
      const parser = new DOMParser();
      const DomDoc = parser.parseFromString(DOMString, "text/html");
      await importHtml(DomDoc);
      
      const DOM = $(DomDoc).find(`yige-component[data-id=${id}]`);
      if (DOM) {
        $(item).replaceWith(DOM.html());
      }
    })();
    promises.push(promise);
  });
  await Promise.all(promises);
};
